// Accessibility: To Announce the total number of items in the dropdown and the active one
const getLiveRegionText = (dropdownOptions, activeIndex: number, liveRegionText): string => {
  if (!dropdownOptions.length) {
    return '';
  }

  const totalItems = dropdownOptions.length;
  const selectedItem = dropdownOptions[activeIndex];
  const selectedItemText = selectedItem ? selectedItem.value : liveRegionText?.dropdownNoItemSelected;

  if (!liveRegionText?.dropdownLiveRegion) {
    return '';
  }

  return liveRegionText?.dropdownLiveRegion
    .replace('{{selectedItemText}}', selectedItemText)
    .replace(/{{totalItems}}/g, totalItems.toString())
    .replace('{{activeItem}}', (activeIndex + 1).toString());
};

export default getLiveRegionText;
